module.exports = __webpack_public_path__ + "img/type_group_activity.dc95064d.png";